export default "__VITE_ASSET__YA1yl9sz__"